var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.fetching ? _c('p', [_vm._v("Loading...")]) : [_c('Status', {
    staticClass: "s-text-secondary s-mb-6",
    attrs: {
      "icon": "check",
      "message": "下單成功！"
    }
  }), _vm._m(0), _c('p', {
    staticClass: "s-text-center s-text-gray s-mb-10"
  }, [_vm._v("團購 ID：" + _vm._s(_vm.groupBuying.groupbuying_number))]), _c('div', {
    staticClass: "s-rounded-lg product-card s-mb-8"
  }, [_c('h2', {
    staticClass: "s-font-bold s-text-xl s-mb-4"
  }, [_vm._v(_vm._s(_vm.groupBuying.groupbuying_product.title))]), _c('table', [_vm._m(1), _c('tr', [_c('td', [_vm._v("取貨期限")]), _c('td', [_vm._v(_vm._s(_vm.endAt))])]), _c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("原價")]), _c('td', [_vm._v(_vm._s(_vm.groupBuying.groupbuying_sku.original_price) + " 元")])]), _c('tr', [_c('td', [_vm._v("售價")]), _vm.groupBuying.groupbuying_sku.is_promotion ? _c('td', [_vm._v(_vm._s(_vm.groupBuying.groupbuying_sku.package_type))]) : _c('td', [_vm._v(_vm._s(_vm.groupBuying.groupbuying_sku.price) + " 元")])]), _c('tr', [_c('td', [_vm._v("下單數量")]), _c('td', {
    staticClass: "s-text-secondary"
  }, [_vm._v(_vm._s(_vm.orderQuantity))])]), _c('tr', [_c('td', [_vm._v("應付金額")]), _c('td', {
    staticClass: "s-text-secondary"
  }, [_vm._v(_vm._s(_vm.paidPrice) + " 元")])])])]), _c('a', {
    staticClass: "s-btn s-btn-primary",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("確認")])]], 2);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-mb-3 s-space-y-3 s-text-center s-text-secondary"
  }, [_c('p', [_vm._v("您已可至門市取貨"), _c('br'), _vm._v("結帳依門市實際價格為準")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tr', [_c('td', [_vm._v("取貨方式")]), _c('td', [_vm._v("門市取貨付款")])]);
}]

export { render, staticRenderFns }